export default __webpack_public_path__ + "static/media/genhaven-color.714242ee.webp";